import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import AreaAbrangenciaModel from "@/models/areaAbrangencia/areaAbrangenciaModel";
import areaAbrangenciaService from "@/services/areaAbrangenciaService";

import ListComponentBase from "../listComponentBase";

import "../crud.scss";

@Component
export default class AreaAbrangenciaListComponent extends ListComponentBase<AreaAbrangenciaModel> {
    get gridColumns(): Array<GridColumn> {
        return [new GridColumn("descricao", "Descrição", GridColumnType.String)];
    }

    private beforeMount() {
        this.setPropsCached(areaAbrangenciaService, "areaAbrangencia", "descricao");
    }
}
